export default __webpack_public_path__ + "static/media/qr-template-small-icon-es.de5b2804.png";